<template>
  <!-- <div>
    <a-menu style="width: 320px" mode="vertical" @click="handleClick">
      <a-sub-menu v-for="menu in allMenus" :key="menu.id">
        <span slot="title"
          ><span>{{ menu.name }}</span></span
        >

        <a-sub-menu
          :title="submenu.name"
          v-for="submenu in menu.submenus"
          :key="submenu.id"
          mode="vertical-right"
        >
          <a-menu-item
            v-for="category in submenu.category_info"
            :key="category.id"
          >
            <div class="mobilemega__menuItems">
              <img :src="require('../../assets/cuisines/newari.jpg')" />
              <span>{{ category.name }}</span>
            </div>
          </a-menu-item>
        </a-sub-menu>
      </a-sub-menu>
    </a-menu>
  </div> -->
  <div>
    <a-menu style="width: 280px" mode="vertical" @click="handleClick">
      <a-sub-menu v-for="menu in allMenus" :key="menu.id">
        <span slot="title"
          ><span>{{ menu.name }}</span></span
        >

        <a-sub-menu v-for="submenu in menu.submenus" :key="submenu.id">
          <span slot="title"
            ><span>{{ submenu.name }}</span></span
          >
          <a-menu-item
            v-for="category in submenu.category_info"
            :key="category.id"
          >
         {{category.name}}
          </a-menu-item>
        </a-sub-menu>
      </a-sub-menu>
    </a-menu>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "TabMegaMenu",
  methods: {
    handleClick(e) {
      console.log("click ", e);
    },
  },
  computed: {
    ...mapGetters(["allMenus"]),
  },
};
</script>

<style scoped>
/* .ant-menu
  >>> .ant-menu-submenu-vertical
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-left
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::before,
.ant-menu-submenu-vertical-right
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::before,
.ant-menu-submenu-inline
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::before {
  transform: rotate(231deg) translateY(-2px);
} */

/* .ant-menu
  >>> .ant-menu-submenu-vertical
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-left
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::after,
.ant-menu-submenu-vertical-right
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::after,
.ant-menu-submenu-inline
  > .ant-menu-submenu-title
  .ant-menu-submenu-arrow::after {
  transform: rotate(134deg) translateY(2px);
} */

.ant-menu >>> .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
  color: red;
}

.ant-menu >>> .ant-menu-sub.ant-menu-inline > .ant-menu-item {
  color: #ed3c3b;
}

.mobilemega__menuItems {
  font-family: "Montserrat", sans-serif;
}

.ant-menu-submenu,
.ant-menu-submenu-inline {
  color: red;
}

.ant-menu-vertical > .ant-menu-item,
.ant-menu-vertical-left > .ant-menu-item,
.ant-menu-vertical-right > .ant-menu-item,
.ant-menu-inline > .ant-menu-item,
.ant-menu-vertical > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-left > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-vertical-right > .ant-menu-submenu > .ant-menu-submenu-title,
.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 40px;
  line-height: 40px;
  color: red;
}

.mobilemega__menuItems > img {
  height: 35px;
  width: 35px;
  margin-right: 15px;
  border-radius: 8px;
  object-fit: cover;
}
</style>
